import { isMobileOrTablet } from './is-mobile'
import { isWebview } from './is-webview'

export type DeviceType = 'mobile' | 'desktop'

export type AppType = 'browser' | 'native' | 'in_app_browser' | 'webview'

export const DeviceHeaderNames = {
  DEVICE_TYPE: 'x-device-type',
  APP_TYPE: 'x-app-type',
} as const

export type DeviceHeaders = {
  [DeviceHeaderNames.DEVICE_TYPE]?: DeviceType
  [DeviceHeaderNames.APP_TYPE]?: AppType
}

export const getDeviceHeaders = () => ({
  [DeviceHeaderNames.APP_TYPE]: isWebview() ? 'webview' : 'browser',
  [DeviceHeaderNames.DEVICE_TYPE]: isMobileOrTablet() ? 'mobile' : 'desktop',
})
